import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesClientsMain } from './modules/ui/Main';

const ClientsPage = (
  <SuspensePage>
    <PagesClientsMain />
  </SuspensePage>
);

export default ClientsPage;
